export class ArtifactoryState {
    constructor() {
        this.states = {};
    }

    getState(name) {
        return this.states[name];
    }

    setState(name, state) {
        this.states[name] = state;
    }

    removeState(name) {
        if (this.states[name] !== undefined) delete this.states[name];
    }

    clearAll(){
        this.states = {};
    }

}


// WEBPACK FOOTER //
// ./services/artifactory_state.js